import { styled } from '@linaria/react';
import { Box, Group, Stack } from '@mantine/core';
import { formatCurrency, getCurrency } from '../../../../../../helpers/currency-helpers';
import { round } from '../../../../../../helpers/math-helpers/math-helpers';
import { useGlobalStore } from '../../../../../../store/global-store/global-store';
import { baseWhite, secondaryBase, skyDark } from '../../../../../../styles/design-tokens';
import { Text } from '../../../../../../ui-library/typography/typography';

export const TreeMapTooltip = ({ active, payload }: { active?: boolean; payload?: any[] }) => {
  const organization = useGlobalStore((state) => state.organization);
  const { code: currencyCode } = getCurrency(organization);
  if (!active || !payload || !payload.length || !payload[0].payload) {
    return null;
  }

  const data = payload[0].payload;
  const { title, name, percentage, actualSize } = data;

  return (
    <TooltipContainer>
      <Stack gap={8}>
        <Group gap={8}>
          <Text color={secondaryBase} size="small">
            {title}
          </Text>
          <Text size="small" weight="bold">
            {formatCurrency(actualSize, { currency: currencyCode })}
          </Text>
          <Text size="small" color={skyDark}>{`(${round(percentage ?? 0, 2)}%)`}</Text>
        </Group>
        {name && (
          <Text size="small" weight="bold" style={{ wordBreak: 'break-word' }}>
            {name}
          </Text>
        )}
      </Stack>
    </TooltipContainer>
  );
};

const TooltipContainer = styled(Box)`
  background-color: ${baseWhite};
  border-radius: 16px;
  padding: 8px 20px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 300px;
`;
